"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OverlayModalWithTitle = exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var React = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactOverlays = require("react-overlays");

var _ThemeProvider = require("../ThemeProvider");

var _style = _interopRequireDefault(require("./style"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var BasicOverlayModal = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(BasicOverlayModal, _React$Component);

  var _super = _createSuper(BasicOverlayModal);

  function BasicOverlayModal() {
    (0, _classCallCheck2["default"])(this, BasicOverlayModal);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(BasicOverlayModal, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          classes = _this$props.classes,
          className = _this$props.className,
          contentClassName = _this$props.contentClassName,
          isOpen = _this$props.isOpen,
          style = _this$props.style,
          children = _this$props.children,
          hideOnBackdropClick = _this$props.hideOnBackdropClick,
          _onHide = _this$props.onHide,
          props = (0, _objectWithoutProperties2["default"])(_this$props, ["classes", "className", "contentClassName", "isOpen", "style", "children", "hideOnBackdropClick", "onHide"]);
      var modalClasses = [classes.OverlayModal];

      if (className) {
        modalClasses.push(className);
      }

      var modalContentClasses = [classes.OverlayModalContent];

      if (contentClassName) {
        modalContentClasses.push(contentClassName);
      }

      return /*#__PURE__*/React.createElement(_reactOverlays.Modal, (0, _extends2["default"])({}, props, {
        backdrop: hideOnBackdropClick ? true : 'static',
        className: modalClasses.join(' '),
        backdropClassName: classes.OverlayModalBackdrop,
        show: isOpen,
        onHide: function onHide() {
          // Pass a mock event to the onHide handler
          _onHide(new Event('onHide', {
            bubbles: true,
            cancelable: false
          }));
        }
      }), /*#__PURE__*/React.createElement("div", {
        className: modalContentClasses.join(' '),
        style: style
      }, /*#__PURE__*/React.createElement("div", {
        className: "stilo-bootstrap"
      }, children)));
    }
  }]);
  return BasicOverlayModal;
}(React.Component);

(0, _defineProperty2["default"])(BasicOverlayModal, "propTypes", {
  children: _propTypes["default"].node,
  classes: _propTypes["default"].object,
  style: _propTypes["default"].object,
  isOpen: _propTypes["default"].bool,
  onHide: _propTypes["default"].func,
  className: _propTypes["default"].string,
  contentClassName: _propTypes["default"].string,
  hideOnBackdropClick: _propTypes["default"].bool
});
(0, _defineProperty2["default"])(BasicOverlayModal, "defaultProps", {
  hideOnBackdropClick: true
});
var OverlayModal = (0, _ThemeProvider.withStyles)(_style["default"])(BasicOverlayModal);
var _default = OverlayModal;
exports["default"] = _default;

var WithTitle = /*#__PURE__*/function (_React$Component2) {
  (0, _inherits2["default"])(WithTitle, _React$Component2);

  var _super2 = _createSuper(WithTitle);

  function WithTitle() {
    (0, _classCallCheck2["default"])(this, WithTitle);
    return _super2.apply(this, arguments);
  }

  (0, _createClass2["default"])(WithTitle, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          classes = _this$props2.classes,
          contentClassName = _this$props2.contentClassName,
          footer = _this$props2.footer,
          children = _this$props2.children,
          title = _this$props2.title,
          props = (0, _objectWithoutProperties2["default"])(_this$props2, ["classes", "contentClassName", "footer", "children", "title"]);
      return /*#__PURE__*/React.createElement(BasicOverlayModal, (0, _extends2["default"])({}, props, {
        classes: classes,
        contentClassName: 'bordered' + (contentClassName ? " ".concat(contentClassName) : '')
      }), title && /*#__PURE__*/React.createElement("div", {
        className: "".concat(classes.OverlayModalTitle, " title")
      }, title), children && /*#__PURE__*/React.createElement("div", {
        className: "".concat(classes.OverlayModalInnerContent, " inner-content")
      }, children), footer && /*#__PURE__*/React.createElement("div", {
        className: "".concat(classes.OverlayModalFooter, " modal-footer")
      }, footer));
    }
  }]);
  return WithTitle;
}(React.Component);

(0, _defineProperty2["default"])(WithTitle, "propTypes", {
  children: _propTypes["default"].oneOfType([_propTypes["default"].element, _propTypes["default"].arrayOf(_propTypes["default"].element)]),
  footer: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].element, _propTypes["default"].arrayOf(_propTypes["default"].element)]),
  title: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].element]),
  classes: _propTypes["default"].object,
  contentClassName: _propTypes["default"].string,
  style: _propTypes["default"].object
});
var OverlayModalWithTitle = (0, _ThemeProvider.withStyles)(_style["default"])(WithTitle);
exports.OverlayModalWithTitle = OverlayModalWithTitle;
//# sourceMappingURL=bootstrap.js.map